var map = {
	"./338915490_1229183217993655_4013507322973239400_n.jpg": 642,
	"./377556176_786346260168191_4893210747034146878_n.jpg": 3417,
	"./397349766_820943556708461_3701822587996804296_n.jpg": 5662,
	"./981062_10202732837425112_2096818334_o.jpg": 516
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 666;